import Markdown from 'react-markdown'
import PropTypes from 'prop-types'
import React, { Component } from 'react'
import { IntlContext } from 'react-intl'
import { invariantIntlContext } from '../utils'

export default class FormattedMarkdownMessage extends Component {
  static propTypes = {
    id: PropTypes.string.isRequired,
    description: PropTypes.string,
    defaultMessage: PropTypes.string,
    values: PropTypes.object,
    containerProps: PropTypes.object,
    containerComponent: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
    renderers: PropTypes.object,
  }

  render() {
    return (
      <IntlContext.Consumer>
        {intl => {
          invariantIntlContext(intl)
          const { formatMessage } = intl
          const { id, description, defaultMessage, values, containerComponent, containerProps, renderers } = this.props

          const formattedMessage = formatMessage(
            {
              id,
              description,
              defaultMessage,
            },
            values
          )

          return (
            <Markdown
              containerProps={containerProps}
              containerTagName={containerComponent}
              renderers={renderers}
              source={formattedMessage}
            />
          )
        }}
      </IntlContext.Consumer>
    )
  }
}
